export default __webpack_public_path__ + "static/media/room-5.a7c5e078.jpeg";